(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7652],{

/***/ 23201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/_internal/for-sale/[address_id]",
      function () {
        return __webpack_require__(80783);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ show; },
/* harmony export */   "qc": function() { return /* binding */ defaultEaseCss; },
/* harmony export */   "vI": function() { return /* binding */ defaultEase; }
/* harmony export */ });
var defaultEase = [
    0.55,
    0,
    0.15,
    1
];
var defaultEaseCss = "cubic-bezier(0.55, 0, 0.15, 1)";
var show = {
    start: {
        opacity: 0,
        y: 24
    },
    end: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            type: "spring"
        }
    }
};


/***/ }),

/***/ 92690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ trapFocus; }
/* harmony export */ });
var trapFocus = function(e, containerRef) {
    var ref;
    if (e.key !== "Tab") return;
    var containerElements = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var firstElement = containerElements && containerElements[0];
    var lastElement = containerElements && containerElements[containerElements.length - 1];
    // tabbing forwards on the last element (Careers)
    if (!e.shiftKey && document.activeElement === lastElement) {
        firstElement.focus();
        return e.preventDefault();
    }
    // tabbing backwards on the first element (Close button)
    if (e.shiftKey && document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
    }
};


/***/ }),

/***/ 29212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ generatePresetPictureSetProps; },
/* harmony export */   "eY": function() { return /* binding */ generatePresetPictureSet; },
/* harmony export */   "t": function() { return /* binding */ Picture; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61442);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);






var Picture = function(param) {
    var preload = param.preload, lazy = param.lazy, radii = param.radii, sources = param.sources, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, customStyles = param.customStyles, fetchPriority = param.fetchPriority;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            preload && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: sources.map(function(param) {
                    var srcSet = param.srcSet, media = param.media, key = param.key;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("link", {
                        rel: "preload",
                        as: "image",
                        href: "",
                        // @ts-expect-error: react incorrectly capitalizes this if you use
                        // the "typescript" suggestion of `imgSrcSet`
                        imagesrcset: srcSet,
                        media: media,
                        fetchpriority: "high"
                    }, "".concat(key, "-preload"));
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
                style: {
                    height: "100%",
                    width: "100%"
                },
                children: [
                    sources.map(function(param) {
                        var srcSet = param.srcSet, media = param.media, key = param.key;
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
                            srcSet: srcSet,
                            media: media
                        }, "".concat(key, "-source"));
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        objectFit: objectFit,
                        width: "100%",
                        height: "100%",
                        alt: ""
                    }, radii), {
                        loading: lazy ? "lazy" : undefined,
                        css: customStyles,
                        // @ts-expect-error: fetchpriority is a valid attribute but missing from the type definition
                        fetchpriority: fetchPriority
                    }))
                ]
            })
        ]
    });
};
var generatePresetPictureSetProps = function(_param) {
    var photoUrl = _param.photoUrl, sizes = _param.sizes, radii = _param.radii, lazy = _param.lazy, _dpr = _param.dpr, dpr = _dpr === void 0 ? [
        1,
        2,
        3
    ] : _dpr, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, objectFit = _param.objectFit, fetchPriority = _param.fetchPriority, quality = _param.quality, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "photoUrl",
        "sizes",
        "radii",
        "lazy",
        "dpr",
        "preload",
        "objectFit",
        "fetchPriority",
        "quality"
    ]);
    // sort in reverse because <source> matches in order, required to use
    // the min-width selectors
    var sortedSizes = sizes.sort(function(a, b) {
        return a.minWidth <= b.minWidth ? -1 : 1;
    });
    var sources = sortedSizes.map(function(param) {
        var minWidth = param.minWidth, maxWidth = param.maxWidth, preset = param.preset, presetScale = param.presetScale;
        var paramsRecord = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            preset: preset
        }, presetScale ? {
            presetScale: presetScale
        } : {}), {
            service: "cosmos",
            auto: "format,compress"
        }), quality !== undefined ? {
            q: "".concat(quality)
        } : {});
        var srcSet = dpr && (dpr === null || dpr === void 0 ? void 0 : dpr.length) > 0 ? dpr.map(function(d) {
            var finalParams = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, paramsRecord), {
                dpr: "".concat(d)
            });
            return "".concat(photoUrl, "?").concat(new URLSearchParams(finalParams).toString(), " ").concat(d, "x");
        }).join(", ") : "".concat(photoUrl, "?").concat(new URLSearchParams(paramsRecord).toString());
        var media = maxWidth === null ? "(min-width: ".concat(minWidth, "px)") : "(min-width: ".concat(minWidth, "px) and (max-width: ").concat(maxWidth - 1, "px)");
        return {
            srcSet: srcSet,
            media: media,
            key: "".concat(photoUrl, "-").concat(minWidth)
        };
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        photoUrl: photoUrl,
        preload: preload,
        lazy: lazy,
        radii: radii,
        sources: sources,
        objectFit: objectFit,
        fetchPriority: fetchPriority
    }, props);
};
var generatePresetPictureSet = function(props) {
    var ref = generatePresetPictureSetProps(props), photoUrl = ref.photoUrl, preload = ref.preload, lazy = ref.lazy, radii = ref.radii, sources = ref.sources, objectFit = ref.objectFit, fetchPriority = ref.fetchPriority;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(Picture, {
        preload: preload,
        lazy: lazy,
        radii: radii,
        sources: sources,
        objectFit: objectFit,
        fetchPriority: fetchPriority
    }, photoUrl);
};


/***/ }),

/***/ 80783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _address_id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/index.ts + 4 modules
var helpers = __webpack_require__(95707);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/useTrackProperty.ts
var useTrackProperty = __webpack_require__(97997);
// EXTERNAL MODULE: ./src/components/marketplace/property/index.ts + 13 modules
var marketplace_property = __webpack_require__(61301);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 22 modules
var Header = __webpack_require__(71678);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/components/properties/components/CoverImages.tsx
// Homes Placeholder SVG
var FALLBACK_URL = "https://images.opendoor.com/source/s3/imgdrop-production/ce1501221958405990f1d0d7fe935c51.svg?preset=square-2048";

;// CONCATENATED MODULE: ./src/components/properties/helpers/property.ts



function getHumanReadableAddress(street, unitType, unitNumber, city, state, postalCode) {
    var formattedStreet = (0,helpers/* formatStreetAddress */.Dm)(street, unitType, unitNumber);
    if (!formattedStreet || !city || !state || !postalCode) {
        return "";
    }
    return "".concat(formattedStreet, ", ").concat(city, ", ").concat(state, " ").concat(postalCode);
}
var getReadableListingStatus = function(listingState) {
    if (!listingState) {
        return "Unknown";
    }
    if (listingState === "SELL_REQUEST_TEMP_OFF_MARKET") {
        return "Off Market";
    }
    return listingState.substring("SELL_REQUEST_".length).split("_").map(function(input) {
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    }).join(" ");
};
var getSeoFields = function(addressId, displaySlug, status, street, unitType, unitNumber, city, state, postalCode, sqFtLot, bedrooms, bathrooms, yearBuilt, coverImageProp) {
    var ref;
    var readableAddress = getHumanReadableAddress(street, unitType, unitNumber, city, state, postalCode);
    var title = "Home for sale - ".concat(readableAddress, " | Opendoor");
    var canonicalUrl = displaySlug ? "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(displaySlug, "/aid_").concat(addressId) : "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(street ? "".concat((ref = street === null || street === void 0 ? void 0 : street.toLowerCase()) === null || ref === void 0 ? void 0 : ref.replaceAll(" ", "-"), "-") : "").concat(unitNumber ? "".concat(unitNumber, "-") : "").concat(city ? "".concat(city === null || city === void 0 ? void 0 : city.toLowerCase(), "-") : "", "-").concat(state === null || state === void 0 ? void 0 : state.toLowerCase()).concat(postalCode, "/aid_").concat(addressId);
    var forSale = getReadableListingStatus(status) === "Active";
    var metaDescription = "".concat(readableAddress, " is currently ").concat(forSale ? "for sale" : "not for sale", ". The ").concat(sqFtLot ? "".concat(sqFtLot, " sq ft.") : "", " home ").concat(yearBuilt ? "was built in ".concat(yearBuilt) : "", " ").concat(bedrooms ? "and has ".concat(bedrooms, " bedrooms") : "", " ").concat(bathrooms ? "and has ".concat(bathrooms, " bathrooms") : "", ". Learn more about the home on Opendoor.");
    var coverImage = FALLBACK_URL;
    if (coverImageProp) {
        coverImage = "".concat(coverImageProp, "?").concat(new URLSearchParams({
            preset: "3:2-sm",
            service: "cosmos"
        }).toString());
    }
    return {
        readableAddress: readableAddress,
        canonicalUrl: canonicalUrl,
        metaDescription: metaDescription,
        title: title,
        coverImage: coverImage
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/properties/shared/SeoHead.tsx




var getBaseTags = function(props) {
    return [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
            children: props.title
        }, "title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "description",
            content: props.metaDescription
        }, "description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "author",
            content: props.author
        }, "author"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
            rel: "canonical",
            href: props.canonicalUrl
        }, "canonical"), 
    ];
};
var getOgTags = function(props) {
    if (!props) {
        return null;
    }
    var url = props.url, title = props.title, description = props.description, image = props.image, siteName = props.siteName, type = props.type;
    var tags = [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:title",
            content: title
        }, "og:title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:url",
            content: url
        }, "og:url"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:type",
            content: type
        }, "og:type"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:description",
            content: description
        }, "og:description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image",
            content: image
        }, "og:image"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:site_name",
            content: siteName
        }, "og:site_name"), 
    ];
    return tags;
};
var getPropertySchemaData = function(props) {
    var address = props.address, floorSize = props.floorSize, listPrice = props.listPrice, url = props.url, lat = props.lat, lon = props.lon, hasSelfTour = props.hasSelfTour, addressToken = props.addressToken, remainingProps = (0,_object_without_properties/* default */.Z)(props, [
        "address",
        "floorSize",
        "listPrice",
        "url",
        "lat",
        "lon",
        "hasSelfTour",
        "addressToken"
    ]);
    var schemaData = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org/",
        "@type": [
            "SingleFamilyResidence",
            "Product"
        ]
    }, address && {
        address: (0,_object_spread/* default */.Z)({
            "@type": "PostalAddress"
        }, address)
    }, lat && lon && {
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lon
        }
    }, floorSize && {
        floorSize: (0,_object_spread/* default */.Z)({
            "@type": "QuantitativeValue"
        }, floorSize)
    }, hasSelfTour && addressToken && {
        tourBookingPage: "https://consumer.opendoor.com/dashboard/buy/tour?id=".concat(addressToken)
    }, listPrice && url && {
        offers: {
            "@type": "Offer",
            priceCurrency: "USD",
            price: listPrice,
            url: url,
            availability: "http://schema.org/InStock"
        }
    }, remainingProps);
    return schemaData;
};
var SeoHead = function(props) {
    var base = props.base, og = props.og, schema = props.schema;
    // ensure that you don't nest tags inside of fragments
    // if you do that, then the next head component
    // will have issues with overrides
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            getBaseTags(base),
            getOgTags(og),
            schema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getPropertySchemaData(schema))
                }
            })
        ]
    });
};
/* harmony default export */ var shared_SeoHead = (SeoHead);

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
;// CONCATENATED MODULE: ./src/components/properties/shared/MarketplaceLayout.tsx












var mainNavLinks = [
    {
        name: "How it works",
        href: "/how-it-works-sell"
    },
    {
        name: "Browse homes",
        href: "/homes"
    }, 
];
var menuPanelNavLinks = [
    {
        name: "Work with a builder",
        href: "/builder"
    },
    {
        name: "Opendoor for Agents",
        href: "/agents"
    }, 
];
var MarketplaceLayout = function(param) {
    var children = param.children, property = param.property, navHeader = param.navHeader;
    var ref;
    var ref1;
    var resolvedMainNavLinks = (ref1 = navHeader === null || navHeader === void 0 ? void 0 : navHeader.mainNavLinks) !== null && ref1 !== void 0 ? ref1 : mainNavLinks;
    var ref2;
    var resolvedMenuPanelNavLinks = (ref2 = navHeader === null || navHeader === void 0 ? void 0 : navHeader.menuPanelNavLinks) !== null && ref2 !== void 0 ? ref2 : menuPanelNavLinks;
    var megaNavData = navHeader === null || navHeader === void 0 ? void 0 : navHeader.megaNavData;
    var ref3 = getSeoFields(property === null || property === void 0 ? void 0 : property.addressToken, property === null || property === void 0 ? void 0 : property.slug, undefined, property === null || property === void 0 ? void 0 : property.street, property === null || property === void 0 ? void 0 : property.unitType, property === null || property === void 0 ? void 0 : property.unitNumber, property === null || property === void 0 ? void 0 : property.city, property === null || property === void 0 ? void 0 : property.state, property === null || property === void 0 ? void 0 : property.zip, property === null || property === void 0 ? void 0 : property.sqFtLot, property === null || property === void 0 ? void 0 : property.bedrooms, property === null || property === void 0 ? void 0 : property.bathrooms, property === null || property === void 0 ? void 0 : property.yearBuilt, property === null || property === void 0 ? void 0 : (ref = property.photos) === null || ref === void 0 ? void 0 : ref[0]), coverImage = ref3.coverImage, readableAddress = ref3.readableAddress, title = ref3.title, canonicalUrl = ref3.canonicalUrl;
    var metaDescription = "View photos, details, and schedule a self-tour of this ".concat(property === null || property === void 0 ? void 0 : property.bedrooms, " bedroom, ").concat(property === null || property === void 0 ? void 0 : property.bathrooms, " bathroom, ").concat(property === null || property === void 0 ? void 0 : property.sqFtTotalLiving, " sqft home located at ").concat(readableAddress, ".");
    var seoHead = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_SeoHead, {
        base: {
            title: title,
            author: "Opendoor, Inc.",
            metaDescription: metaDescription,
            canonicalUrl: canonicalUrl
        },
        og: {
            url: canonicalUrl,
            title: title,
            description: metaDescription,
            siteName: "Opendoor",
            image: coverImage,
            type: "website"
        },
        schema: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            name: readableAddress,
            description: metaDescription,
            url: canonicalUrl,
            address: (0,_object_spread/* default */.Z)({}, (property === null || property === void 0 ? void 0 : property.street) && {
                streetAddress: (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber) || undefined
            }, (property === null || property === void 0 ? void 0 : property.city) && {
                addressLocality: property.city
            }, (property === null || property === void 0 ? void 0 : property.state) && {
                addressRegion: property.state
            }, (property === null || property === void 0 ? void 0 : property.zip) && {
                postalCode: property.zip
            })
        }, (property === null || property === void 0 ? void 0 : property.sqFtLot) && {
            floorSize: {
                value: property.sqFtLot.toString()
            }
        }, (property === null || property === void 0 ? void 0 : property.yearBuilt) && {
            yearBuilt: property.yearBuilt.toString()
        }, (property === null || property === void 0 ? void 0 : property.bedrooms) && {
            numberOfBedrooms: property.bedrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.bathrooms) && {
            numberOfBathroomsTotal: property.bathrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.listPrice) && !(0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.listPrice
        }, (property === null || property === void 0 ? void 0 : property.buyDirectPrice) && (0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.buyDirectPrice
        }), {
            image: coverImage,
            lat: property === null || property === void 0 ? void 0 : property.latitude,
            lon: property === null || property === void 0 ? void 0 : property.longitude
        }), (property === null || property === void 0 ? void 0 : property.canSelfTour) && {
            hasSelfTour: property === null || property === void 0 ? void 0 : property.canSelfTour
        }), {
            addressToken: property === null || property === void 0 ? void 0 : property.addressToken
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
        baseTheme: "novo",
        team: "marketplace",
        launchDateString: new Date().toISOString(),
        overrides: {},
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "viewport",
                        content: "width=device-width,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "Accept-CH",
                        content: "DPR, Width, Viewport-Width"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: "https://www.opendoor.com/apple-touch-icon-144.png"
                    })
                ]
            }),
            seoHead,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {
                fontWeights: [
                    "regular",
                    "semibold",
                    "bold",
                    "medium"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "column",
                backgroundColor: "$backgroundPrimary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        slug: "homes",
                        mainNavLinks: resolvedMainNavLinks,
                        menuPanelNavLinks: resolvedMenuPanelNavLinks,
                        megaNavData: megaNavData,
                        ctaTitle: navHeader === null || navHeader === void 0 ? void 0 : navHeader.ctaTitle,
                        ctaLink: navHeader === null || navHeader === void 0 ? void 0 : navHeader.ctaLink
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        tag: "main",
                        tabIndex: -1,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        overflowX: "hidden",
                        backgroundColor: "$backgroundPrimary",
                        children: children
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_MarketplaceLayout = (MarketplaceLayout);

// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
;// CONCATENATED MODULE: ./src/pages/marketplace/_internal/for-sale/[address_id].tsx










var Page = function(props) {
    var property = props === null || props === void 0 ? void 0 : props.property;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(useTrackProperty/* PropertyAnalytics.Provider */.K.Provider, {
        value: {
            property: property
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageInner, (0,_object_spread/* default */.Z)({}, props))
    });
};
var PageInner = function(param) {
    var property = param.property, navHeader = param.navHeader;
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var ref = (0,react.useState)(false), isLightboxOpen = ref[0], setIsLightboxOpen = ref[1];
    var ref1 = (0,react.useState)(false), isShareModalOpen = ref1[0], setIsShareModalOpen = ref1[1];
    var ref2 = (0,react.useState)(0), selectedPhotoIndex = ref2[0], setSelectedPhotoIndex = ref2[1];
    var toggleLightbox = (0,react.useCallback)(function() {
        return setIsLightboxOpen(function(prev) {
            return !prev;
        });
    }, []);
    var handleSetSelectedPhotoIndex = (0,react.useCallback)(function(idx) {
        return setSelectedPhotoIndex(idx);
    }, []);
    var ref3 = (0,helpers/* usePropertyReactions */.O8)(property.addressToken, "REACTION_SOURCE_WEB_PDP"), isLiked = ref3.isLiked, onClickReaction = ref3.onClickReaction;
    /**
   * The initial page load for customers will include the cached similar properties.
   * This hook executes client-side to retrieve the latest similar listings.
   */ var marketplaceProperty = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, property), {
        isLiked: isLiked,
        onClickReaction: onClickReaction
    });
    var similarProperties = (0,helpers/* useSimilarProperties */.n6)(property.addressToken).similarProperties;
    if (similarProperties === null || similarProperties === void 0 ? void 0 : similarProperties.results) {
        marketplaceProperty.similarProperties = similarProperties;
    }
    var sellerDisclosures = (0,helpers/* useSellerDisclosures */.FZ)(property.addressToken).sellerDisclosures;
    if (sellerDisclosures) {
        marketplaceProperty.sellerDisclosuresDownloadUrl = sellerDisclosures;
    }
    var formattedAddress = (0,react.useMemo)(function() {
        return (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber);
    }, [
        property.street,
        property.unitType,
        property.unitNumber
    ]);
    (0,react.useEffect)(function() {
        trackProperty("property-view", "marketplace-pdp");
        trackJourneyEvent("marketplaceProperty", "detailPageView", {
            addressUuid: property.addressToken
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_MarketplaceLayout, {
        property: marketplaceProperty,
        navHeader: navHeader,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            $smallerThanMD: {
                flexDirection: "column",
                overflowY: "scroll"
            },
            $largerThanSM: {
                flexDirection: "row",
                height: "calc(100vh - 72px)"
            },
            overflow: "hidden",
            width: "100vw",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* GalleryPhotos */.Ub, {
                    handleSetSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                    property: marketplaceProperty,
                    toggleLightbox: toggleLightbox
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* PhotoCarousel */.cS, {
                    photos: marketplaceProperty === null || marketplaceProperty === void 0 ? void 0 : marketplaceProperty.photos,
                    price: (marketplaceProperty === null || marketplaceProperty === void 0 ? void 0 : marketplaceProperty.displayBadge) === "ON_THE_MARKET" && (0,helpers/* isBuyDirectEligible */.pX)(marketplaceProperty) ? marketplaceProperty.buyDirectPrice : marketplaceProperty.listPrice,
                    address: formattedAddress,
                    toggleLightbox: toggleLightbox,
                    setSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                    latitude: marketplaceProperty.latitude,
                    longitude: marketplaceProperty.longitude,
                    openShareModal: function() {
                        return setIsShareModalOpen(true);
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* Lightbox */.ey, {
                    handleClose: toggleLightbox,
                    isOpen: isLightboxOpen,
                    property: marketplaceProperty,
                    selectedPhotoIndex: selectedPhotoIndex
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* PropertySection */.qH, {
                    property: marketplaceProperty
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ShareModal */.V8, {
                    property: marketplaceProperty,
                    isOpen: isShareModalOpen,
                    onClose: function() {
                        return setIsShareModalOpen(false);
                    }
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _address_id_ = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6577,6523,6665,5527,7208,1572,7166,9652,5266,6398,2864,5490,4370,8111,7460,8610,1678,1301,9774,2888,179], function() { return __webpack_exec__(23201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);